'use client';
import { hasCldImage, TypeImageWrapper } from '@fm-nx/contentful-types';
import TextMarkdown from '../text-markdown/text-markdown';
import { CldImage } from 'next-cloudinary';
import classNames from 'classnames';

interface PageSectionDisplayProps {
    overline?: string;
    title?: string;
    body?: string;
    imagePlacement: 'left' | 'right';
    imageWrapper: TypeImageWrapper<'WITHOUT_UNRESOLVABLE_LINKS'>;
    buttonsSlot?: React.ReactNode;
}

export const PageSectionDisplay = (props: PageSectionDisplayProps) => {
    // console.log({ props });
    const { overline, title, body, imagePlacement, imageWrapper, buttonsSlot } = props;
    const imageCloudinary = hasCldImage(imageWrapper?.fields) ? imageWrapper?.fields.cloudinaryMedia[0] : null;
    const public_id = imageCloudinary?.public_id;

    return (
        <div className="py-24 overflow-hidden bg-white sm:py-32">
            <div className="px-6 mx-auto max-w-7xl lg:px-8">
                <div className="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="h5 overline">{overline}</h2>
                            <h3 className="h-xl">{title}</h3>
                            {body && (
                                <div className="mt-6">
                                    <TextMarkdown text={body} />
                                </div>
                            )}
                            {buttonsSlot}
                        </div>
                    </div>
                    {public_id && (
                        <div
                            className={classNames({
                                'flex items-start justify-end lg:order-first': imagePlacement === 'left',
                            })}
                        >
                            <CldImage
                                className="z-0 object-cover w-full h-full"
                                src={`${public_id}`}
                                alt={imageWrapper.fields.altText || imageWrapper.fields.title || ''}
                                width={1600}
                                height={1600}
                                sizes="(max-width: 767px) 100vw,(min-width: 768px) 40vw"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageSectionDisplay;
